module.exports = __webpack_public_path__ + "static/tegelwerk-1-555e74a8c4ed085705011c89a18105a3.jpg";